import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { TextField, DropDownMenu, MenuItem } from 'material-ui';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';


import Btn from '../../../components/Btn';
import '../../../grid.css';

class Loan extends Component {
    static propTypes = {
        downPayment: PropTypes.number.isRequired,
        loanTerm: PropTypes.number.isRequired,
        isVisible: PropTypes.bool.isRequired,
        loanInterest: PropTypes.number.isRequired,
        isLocked: PropTypes.bool.isRequired,
        setLoanIsVisible: PropTypes.func.isRequired,
        setLoanTerm: PropTypes.func.isRequired,
        setLoanInterest: PropTypes.func.isRequired,
        setDownPayment: PropTypes.func.isRequired,
        setMosaicTerm: PropTypes.func.isRequired,
        setMosaicInterest: PropTypes.func.isRequired,
        setMosaicDownPayment: PropTypes.func.isRequired,
        mosaicTerm: PropTypes.number.isRequired,
        mosaicDownPayment: PropTypes.number.isRequired,
        setLoanProvider: PropTypes.func.isRequired,
        loanProvider: PropTypes.string.isRequired,
        showLoan: PropTypes.bool.isRequired,
        setShowLoan: PropTypes.func.isRequired,
        setSelectedFinancing: PropTypes.func.isRequired,
    };

    toggleLoanTerms() {
        const { setLoanIsVisible, isVisible } = this.props;
        setLoanIsVisible(!isVisible);
    }

    toggleShowLoan() {
        const { setShowLoan, showLoan, setSelectedFinancing } = this.props;
        setShowLoan(!showLoan);
        if (showLoan) {
            setSelectedFinancing(4);
        }
        if (!showLoan) {
            setSelectedFinancing(2);
        }
    }

    handleLoanTermChange(value) {
        const { setLoanTerm } = this.props;
        setLoanTerm(Number(value));
    }

    handleLoanInterstChange(value) {
        const { setLoanInterest } = this.props;
        setLoanInterest(Number(value));
    }

    handleDownPaymentChange(value) {
        const { setDownPayment } = this.props;
        setDownPayment(Number(value));
    }

    handleMosaicDownPaymentChange(value) {
        const { setMosaicDownPayment } = this.props;
        setMosaicDownPayment(value);
    }

    handleMosaicTermChange(value) {
        const { setMosaicTerm } = this.props;
        setMosaicTerm(value);
    }

    handleMosaicInterestChange(value) {
        const { setMosaicInterest } = this.props;
        setMosaicInterest(Number(value));
    }

    handleLoanProviderChange(value) {
        const { setLoanProvider } = this.props;
        setLoanProvider(value);
    }

    render() {
        const {
            downPayment,
            loanInterest,
            loanTerm,
            isVisible,
            isLocked,
            mosaicTerm,
            mosaicDownPayment,
            loanProvider,
            showLoan,
        } = this.props;

        return (
            <div>
                <Btn
                    label="Loan"
                    onClick={(e, value) => this.toggleLoanTerms(value)}
                />
                {isVisible ? (
                    <div>
                        <div className="col span-1-of-8 checkboxes">
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        disabled={isLocked}
                                        onChange={(e, value) => this.toggleShowLoan(value)}
                                        checked={showLoan}
                                    />
                                }
                                label="Include Loan"
                            />
                        </div>
                        {showLoan ? (
                            <div>
                                <div className="row">
                                    <div className="col span-1-of-8">
                                        <DropDownMenu
                                            fullWidth
                                            label="Loan Provider"
                                            value={loanProvider}
                                            onChange={
                                                (e, index, value) =>
                                                    this.handleLoanProviderChange(value)}
                                            disabled={isLocked}
                                        >
                                            <MenuItem value="mosaic" primaryText="Mosaic" />
                                            <MenuItem value="traditional" primaryText="traditional" />
                                        </DropDownMenu>
                                    </div>
                                    {loanProvider === 'custom' ? (
                                        <div>
                                            <div className="col span-1-of-4">
                                                <TextField
                                                    hintText="7.9"
                                                    defaultValue={loanInterest}
                                                    onChange={
                                                        (e, value) =>
                                                            this.handleLoanInterstChange(value)}
                                                    floatingLabelText="Loan Interest(%)"
                                                    disabled={isLocked}
                                                />
                                            </div>
                                            <div className="col span-1-of-4">
                                                <TextField
                                                    hintText="20"
                                                    defaultValue={loanTerm}
                                                    onChange={
                                                        (e, value) =>
                                                            this.handleLoanTermChange(value)}
                                                    floatingLabelText="Loan Term (months)"
                                                    disabled={isLocked}
                                                />
                                            </div>
                                            <div className="col span-1-of-4">
                                                <TextField
                                                    defaultValue={downPayment}
                                                    onChange={
                                                        (e, value) =>
                                                            this.handleDownPaymentChange(value)}
                                                    hintText="0.085"
                                                    floatingLabelText="Down Payment"
                                                    disabled={isLocked}
                                                />
                                            </div>
                                        </div>
                                    ) : null}
                                    {loanProvider === 'mosaic' ? (
                                        <div>
                                            <div className="col span-1-of-4">
                                                <DropDownMenu
                                                    fullWidth
                                                    label="Mosaic Term"
                                                    value={mosaicTerm}
                                                    onChange={(e, index, value) =>
                                                        this.handleMosaicTermChange(value)}
                                                    disabled={isLocked}
                                                >
                                                    <MenuItem value={120} primaryText="10 Year / 3.99%" />
                                                    <MenuItem value={180} primaryText="15 Year / 4.99%" />
                                                    <MenuItem value={240} primaryText="20 Year / 5.49%" />
                                                </DropDownMenu>
                                            </div>
                                            <div className="col span-1-of-4">
                                                <TextField
                                                    defaultValue={mosaicDownPayment}
                                                    onChange={(e, value) =>
                                                        this.handleMosaicDownPaymentChange(value)}
                                                    hintText="5000"
                                                    floatingLabelText="Down Payment"
                                                    disabled={isLocked}
                                                />
                                            </div>
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                        ) : null}
                    </div>

                ) : null}
            </div>
        );
    }
}

export default Loan;



// WEBPACK FOOTER //
// ./src/containers/Inputs/Loan/Loan.js